// Manual Filter Application Override
// This script handles the new popover-based filter system with checkboxes and sort integration

document.addEventListener("DOMContentLoaded", function () {
  // Track filter changes and provide visual feedback
  let filtersChanged = false;
  let sortChanged = false;
  const filterButton = document.querySelector(".filters-bar__apply");

  // Get both desktop and mobile forms
  const desktopFilterForm = document.getElementById("CollectionFilterForm");
  const mobileFilterForm = document.getElementById(
    "CollectionFilterFormMobile"
  );
  const filterForm = desktopFilterForm || mobileFilterForm; // Use whichever exists

  let sortInput = document.getElementById("sort-selection");

  // Helper function to check if an element is within a mobile-only container
  function isMobileOnlyElement(element) {
    return element.closest(".mobile-only") !== null;
  }

  // Helper function to check if we should ignore this element (mobile-only on desktop)
  function shouldIgnoreElement(element) {
    if (isMobileOnlyElement(element)) {
      const isDesktop = window.innerWidth >= 768;
      return isDesktop;
    }
    return false;
  }

  // Function to get the active form based on current context
  function getActiveForm() {
    const isDesktop = window.innerWidth >= 768;
    if (isDesktop && desktopFilterForm) {
      return desktopFilterForm;
    } else if (!isDesktop && mobileFilterForm) {
      return mobileFilterForm;
    }
    return filterForm; // fallback
  }

  // Function to get the current sort input (in case it's created dynamically)
  function getCurrentSortInput() {
    return document.getElementById("sort-selection") || sortInput;
  }

  // Function to ensure mobile checkboxes are enabled on mobile
  function ensureMobileCheckboxesEnabled() {
    const isMobile = window.innerWidth < 768;
    if (isMobile) {
      const mobileCheckboxes = document.querySelectorAll(
        ".mobile-only input[type='checkbox']"
      );
      mobileCheckboxes.forEach((checkbox) => {
        if (checkbox.disabled) {
          checkbox.disabled = false;
        }
      });
    }
  }

  // Function to populate filter values from URL parameters
  function populateFiltersFromURL() {
    const urlParams = new URLSearchParams(window.location.search);

    // Handle sort selection
    if (sortInput) {
      const currentSort = urlParams.get("sort_by");
      if (currentSort !== null && currentSort !== "") {
        sortInput.value = currentSort;
        sortInput.setAttribute("data-original-value", currentSort);

        // Update sort button text
        updateSortButtonText(currentSort);
      } else {
        sortInput.setAttribute("data-original-value", sortInput.value || "");
      }
    }

    // Handle filter checkboxes, radio buttons, and price range inputs
    const allFilterInputs = document.querySelectorAll(
      'input[name^="filter."], input[name="sort_by"], .cc-price-range__input'
    );
    allFilterInputs.forEach((input) => {
      if (shouldIgnoreElement(input)) {
        return;
      }

      const paramName = input.name;
      const inputType = input.type;

      if (inputType === "checkbox") {
        // For checkboxes, check if this value is in the URL
        const urlValues = urlParams.getAll(paramName);
        const isChecked = urlValues.includes(input.value);
        input.checked = isChecked;
        // Set initial state for change tracking
        input.setAttribute("data-initial-checked", isChecked);
        input.setAttribute("data-has-been-changed", "false");
      } else if (inputType === "radio") {
        // For radio buttons, check if this value matches the URL
        const urlValue = urlParams.get(paramName);
        const isChecked = urlValue === input.value;
        input.checked = isChecked;
        // Set initial state for change tracking
        input.setAttribute("data-initial-checked", isChecked);
        input.setAttribute("data-has-been-changed", "false");
      } else {
        // For other inputs (like price range)
        if (urlParams.has(paramName)) {
          const urlValue = urlParams.get(paramName);
          if (urlValue !== null && urlValue !== "") {
            input.value = urlValue;
            input.setAttribute("data-original-value", urlValue);
          } else {
            input.setAttribute("data-original-value", "");
          }
        } else {
          input.setAttribute("data-original-value", input.value || "");
        }
      }
    });

    // Update filter button texts
    updateAllFilterButtonTexts();
  }

  // Function to update sort button text
  function updateSortButtonText(sortValue) {
    const sortButton = document.querySelector(".sort-popover-toggle span");
    if (sortButton && sortValue) {
      // Find the sort option name
      const sortItem = document.querySelector(
        `[data-sort-value="${sortValue}"]`
      );
      if (sortItem) {
        const sortName = sortItem
          .querySelector(".filter-group__item__text")
          .textContent.trim();

        // Clear existing content and add new text
        sortButton.innerHTML = "";
        sortButton.textContent = sortName;

        // Re-add the chevron icon
        // const chevron = document.createElement("svg");
        // chevron.className = "filter-chevron";
        // chevron.setAttribute("width", "21");
        // chevron.setAttribute("height", "20");
        // chevron.setAttribute("viewBox", "0 0 21 20");
        // chevron.setAttribute("fill", "none");
        // chevron.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        // chevron.innerHTML =
        //   '<path d="M10.1992 13.0625L5.19922 8.0625L6.26172 7L10.1992 10.9375L14.1367 7L15.1992 8.0625L10.1992 13.0625Z" fill="#3C3C3D"/>';
        // sortButton.appendChild(chevron);
      }
    }
  }

  // Function to update all filter button texts
  function updateAllFilterButtonTexts() {
    const filterButtons = document.querySelectorAll(
      ".filter-popover-toggle, .price-popover-toggle, .availability-popover-toggle"
    );
    filterButtons.forEach((button) => {
      if (button.classList.contains("price-popover-toggle")) {
        updatePriceButtonText(button);
      } else {
        updateFilterButtonText(button);
      }
    });
  }

  // Function to update a specific filter button text
  function updateFilterButtonText(button) {
    const filterParam = button.getAttribute("data-filter-param");
    if (!filterParam) return;

    const checkboxes = document.querySelectorAll(
      `input[name="${filterParam}"]:checked`
    );

    // Get the original text without count, preserving any SVG elements
    const originalText = button.textContent.replace(/\(\d+\)/, "").trim();

    // Store the SVG elements if they exist
    const svgElements = button.querySelectorAll("svg");
    const svgArray = Array.from(svgElements);

    // if (checkboxes.length > 0) {
    //   button.textContent = originalText + ` (${checkboxes.length})`;
    // } else {
    //   button.textContent = originalText;
    // }

    // Re-append the SVG elements
    svgElements.forEach((svg) => {
      button.appendChild(svg);
    });
  }

  // Function to update price button text
  function updatePriceButtonText(button) {
    const priceRange = button
      .closest(".filter-group")
      .querySelector(".cc-price-range");
    if (!priceRange) return;

    const minInput = priceRange.querySelector(".cc-price-range__input--min");
    const maxInput = priceRange.querySelector(".cc-price-range__input--max");

    if (minInput && maxInput) {
      const minValue = minInput.value || minInput.placeholder || "0";
      const maxValue = maxInput.value || maxInput.placeholder || "∞";

      // Update button text to show price range
      const originalText = button.textContent.replace(/\([^)]*\)/, "").trim();
      // button.textContent = originalText + ` (${minValue} - ${maxValue})`;

      // Re-add the chevron icon
      // const chevron = document.createElement("svg");
      // chevron.className = "filter-chevron";
      // chevron.setAttribute("width", "21");
      // chevron.setAttribute("height", "20");
      // chevron.setAttribute("viewBox", "0 0 21 20");
      // chevron.setAttribute("fill", "none");
      // chevron.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      // chevron.innerHTML =
      //   '<path d="M10.1992 13.0625L5.19922 8.0625L6.26172 7L10.1992 10.9375L14.1367 7L15.1992 8.0625L10.1992 13.0625Z" fill="#3C3C3D"/>';
      // button.appendChild(chevron);
    }
  }

  // Function to handle sort popover integration
  function handleSortSelection(sortValue, sortName) {
    const currentSortInput = getCurrentSortInput();

    if (currentSortInput) {
      const originalValue =
        currentSortInput.getAttribute("data-original-value") || "";
      currentSortInput.value = sortValue;

      // Check if sort has changed
      if (sortValue !== originalValue) {
        sortChanged = true;
      } else {
        sortChanged = false;
      }

      if (
        currentSortInput.parentElement.classList.contains(
          "filter-group__item--active"
        )
      ) {
        currentSortInput.parentElement.classList.remove(
          "filter-group__item--active"
        );
      }
    }

    // Update the sort button text
    const sortButton = document.querySelector(".sort-popover-toggle");
    if (sortButton) {
      // Clear existing content and add new text
      sortButton.innerHTML = "";
      sortButton.textContent = sortName;

      // Re-add the chevron icon
      const chevron = document.createElement("svg");
      chevron.className = "filter-chevron";
      chevron.setAttribute("width", "21");
      chevron.setAttribute("height", "20");
      chevron.setAttribute("viewBox", "0 0 21 20");
      chevron.setAttribute("fill", "none");
      chevron.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      chevron.innerHTML =
        '<path d="M10.1992 13.0625L5.19922 8.0625L6.26172 7L10.1992 10.9375L14.1367 7L15.1992 8.0625L10.1992 13.0625Z" fill="#3C3C3D"/>';
      sortButton.appendChild(chevron);
    }

    // Update active state in popover
    const sortItems = document.querySelectorAll(
      ".sort-popover .filter-group__item"
    );
    sortItems.forEach(function (item) {
      item.classList.remove("filter-group__item--active");
      if (item.getAttribute("data-sort-value") === sortValue) {
        item.classList.add("filter-group__item--active");
      }
    });

    // Close the popover
    const sortPopover = document.querySelector(".sort-popover");
    if (sortPopover) {
      sortPopover.classList.remove("show");
    }
    const sortToggle = document.querySelector(".sort-popover-toggle");
    if (sortToggle) {
      sortToggle.setAttribute("aria-expanded", "false");
    }

    // Update filter button state
    updateFilterButtonState();
  }

  // Function to check if any filters have changed
  function checkFilterChanges() {
    const allFilterInputs = document.querySelectorAll(
      'input[name^="filter."], .cc-price-range__input'
    );
    let hasChanges = false;

    allFilterInputs.forEach((input) => {
      if (shouldIgnoreElement(input)) {
        return;
      }

      const inputType = input.type;
      let hasChanged = false;

      if (inputType === "checkbox") {
        const originalCheckedAttr = input.getAttribute("data-original-checked");
        const hasBeenChanged = input.getAttribute("data-has-been-changed");
        const initialChecked = input.getAttribute("data-initial-checked");

        if (
          input.parentElement.classList.contains(
            "filter-group__item--active"
          ) &&
          initialChecked
        ) {
          input.parentElement.classList.remove("filter-group__item--active");
        }

        // If data-original-checked is not set, any change from current state is a change
        if (originalCheckedAttr === null) {
          // For checkboxes without original state, we need to track changes differently
          // We'll use a temporary attribute to track if this checkbox has been changed
          if (hasBeenChanged !== "true") {
            // First time checking this checkbox, mark it as unchanged
            input.setAttribute("data-has-been-changed", "false");
            hasChanged = false;
          } else {
            // Checkbox has been interacted with, check if it's different from initial state
            hasChanged = input.checked !== (initialChecked === "true");
          }
        } else {
          // data-original-checked is set, compare with it
          const originalChecked = originalCheckedAttr === "true";
          hasChanged = input.checked !== originalChecked;
        }
      } else if (inputType === "radio") {
        const originalCheckedAttr = input.getAttribute("data-original-checked");
        // If data-original-checked is not set, any change from current state is a change
        if (originalCheckedAttr === null) {
          // For radio buttons without original state, we need to track changes differently
          const hasBeenChanged = input.getAttribute("data-has-been-changed");
          if (hasBeenChanged !== "true") {
            // First time checking this radio, mark it as unchanged
            input.setAttribute("data-has-been-changed", "false");
            hasChanged = false;
          } else {
            // Radio has been interacted with, check if it's different from initial state
            const initialChecked =
              input.getAttribute("data-initial-checked") === "true";
            hasChanged = input.checked !== initialChecked;
          }
        } else {
          // data-original-checked is set, compare with it
          const originalChecked = originalCheckedAttr === "true";
          hasChanged = input.checked !== originalChecked;
        }
      } else {
        const originalValue = input.getAttribute("data-original-value") || "";
        hasChanged = input.value !== originalValue;
      }

      if (hasChanged) {
        hasChanges = true;
      }
    });

    return hasChanges;
  }

  // Function to update filter button state
  function updateFilterButtonState() {
    if (filterButton) {
      const filterChanges = checkFilterChanges();
      const sortChanges = sortChanged;

      if (filterChanges || sortChanges) {
        // filterButton.setAttribute("data-filters-pending", "true");
        filterButton.textContent = "Filtruoti";
      } else {
        // filterButton.removeAttribute("data-filters-pending");
        filterButton.textContent = "Filtruoti";
      }
    }
  }

  // Make function globally accessible
  window.updateFilterButtonState = updateFilterButtonState;

  // Function to handle form submission
  function handleFormSubmission(event) {
    if (event) {
      event.preventDefault();
    }

    const activeForm = getActiveForm();
    if (!activeForm) {
      console.error("No active form found");
      return;
    }

    // Handle sort selection first - ALWAYS include it in the form
    const currentSortInput = getCurrentSortInput();

    if (currentSortInput) {
      // Look specifically for a hidden input with name="sort_by", not checkboxes
      let formSortInput = activeForm.querySelector(
        'input[type="hidden"][name="sort_by"]'
      );

      if (!formSortInput) {
        formSortInput = document.createElement("input");
        formSortInput.type = "hidden";
        formSortInput.name = "sort_by";
        activeForm.appendChild(formSortInput);
      }
      formSortInput.value = currentSortInput.value;
    } else {
      console.error("currentSortInput element not found!");
    }

    // Disable all mobile-only inputs on desktop before submission
    const isDesktop = window.innerWidth >= 768;
    if (isDesktop) {
      const mobileOnlyInputs = document.querySelectorAll(
        ".mobile-only input, .mobile-only select"
      );
      mobileOnlyInputs.forEach((input) => {
        input.setAttribute("data-original-disabled", input.disabled);
        input.disabled = true;
      });
    } else {
      // On mobile, ensure mobile checkboxes are enabled
      ensureMobileCheckboxesEnabled();
    }

    // Check if there are any meaningful filter values
    const formData = new FormData(activeForm);
    let hasMeaningfulFilters = false;
    let hasSortSelection = false;

    for (const [key, value] of formData.entries()) {
      if (key.startsWith("filter.") && value !== "" && value !== null) {
        hasMeaningfulFilters = true;
      }
      if (key === "sort_by" && value !== "" && value !== null) {
        hasSortSelection = true;
      }
    }

    // Also check checked checkboxes directly since FormData might not include unchecked ones
    const checkedCheckboxes = document.querySelectorAll(
      'input[name^="filter."]:checked'
    );
    checkedCheckboxes.forEach((checkbox) => {
      if (
        checkbox.name.startsWith("filter.") &&
        checkbox.value !== "" &&
        checkbox.value !== null
      ) {
        hasMeaningfulFilters = true;
      }
    });

    // Check price range inputs since they're outside the form
    const priceInputs = document.querySelectorAll(".cc-price-range__input");
    priceInputs.forEach((input) => {
      if (shouldIgnoreElement(input)) {
        return;
      }
      if (
        input.name.startsWith("filter.") &&
        input.value !== "" &&
        input.value !== null
      ) {
        hasMeaningfulFilters = true;
      }
    });

    // Ensure all checked checkboxes are properly included in the form
    const checkedFilterCheckboxes = document.querySelectorAll(
      'input[name^="filter."]:checked'
    );

    checkedFilterCheckboxes.forEach((checkbox) => {
      // Make sure the checkbox is enabled and in the form
      checkbox.disabled = false;
      checkbox.removeAttribute("disabled");

      // If checkbox is not in the active form, add it
      if (!activeForm.contains(checkbox)) {
        activeForm.appendChild(checkbox);
      }
    });

    // Handle price range inputs - create hidden inputs in the form for price values
    // Remove any existing hidden inputs we might have added previously
    const existingHiddenPriceInputs = activeForm.querySelectorAll(
      'input[type="hidden"][name^="filter.v.price"]'
    );
    existingHiddenPriceInputs.forEach((input) => {
      activeForm.removeChild(input);
    });

    // Add all price range inputs to the form
    const allPriceInputs = document.querySelectorAll(".cc-price-range__input");
    allPriceInputs.forEach((input) => {
      if (shouldIgnoreElement(input)) {
        return;
      }

      // Only add if the input has a value
      if (input.value && input.value.trim() !== "") {
        // Create a hidden input in the form with the same name and value
        const hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = input.name;
        hiddenInput.value = input.value;
        activeForm.appendChild(hiddenInput);
      }
    });

    // Reset all changed indicators
    const allFilterInputs = document.querySelectorAll(
      'input[name^="filter."], .cc-price-range__input'
    );
    allFilterInputs.forEach((input) => {
      if (shouldIgnoreElement(input)) {
        return;
      }

      const inputType = input.type;
      if (inputType === "checkbox" || inputType === "radio") {
        input.setAttribute("data-original-checked", input.checked);
        // Clean up temporary tracking attributes
        input.removeAttribute("data-has-been-changed");
        input.removeAttribute("data-initial-checked");
      } else {
        input.setAttribute("data-original-value", input.value);
      }
    });

    filtersChanged = false;
    sortChanged = false;

    if (filterButton) {
      filterButton.removeAttribute("data-filters-pending");
      filterButton.textContent = "Filtruoti";
    }

    // Update sort input original value
    const sortInputForUpdate = getCurrentSortInput();
    if (sortInputForUpdate) {
      sortInputForUpdate.setAttribute(
        "data-original-value",
        sortInputForUpdate.value
      );
    }

    const elementsToDelete = document.querySelectorAll(".price-popover input");
    elementsToDelete.forEach((element) => {
      element.name = "test";
      element.remove();
    });

    // If no meaningful filters and no sort selection, redirect to clean URL
    if (!hasMeaningfulFilters && !hasSortSelection) {
      const baseUrl = window.location.pathname;
      const query = formData.get("q");

      let redirectUrl = baseUrl;
      const params = new URLSearchParams();

      if (query && query !== "") {
        params.set("q", query);
      }

      if (params.toString()) {
        redirectUrl += "?" + params.toString();
      }

      window.location.href = redirectUrl;
      return;
    }
    // Submit the form normally
    activeForm.submit();

    // Re-enable mobile-only inputs after submission
    if (isDesktop) {
      setTimeout(() => {
        const mobileOnlyInputs = document.querySelectorAll(
          ".mobile-only input, .mobile-only select"
        );
        mobileOnlyInputs.forEach((input) => {
          const originalDisabled = input.getAttribute("data-original-disabled");
          if (originalDisabled === "true") {
            input.disabled = true;
          } else {
            input.disabled = false;
          }
          input.removeAttribute("data-original-disabled");
        });
      }, 100);
    }
  }

  // Populate filters from URL parameters on page load
  setTimeout(() => {
    // Re-find the sort input in case it was created dynamically
    const currentSortInput = document.getElementById("sort-selection");
    if (currentSortInput && currentSortInput !== sortInput) {
      sortInput = currentSortInput;
    }
    populateFiltersFromURL();
    ensureMobileCheckboxesEnabled();
  }, 100);

  // Listen for filter changes
  document.addEventListener(
    "change",
    function (event) {
      const targetForm = event.target.closest(
        "#CollectionFilterForm, #CollectionFilterFormMobile"
      );
      if (
        targetForm &&
        (event.target.type === "checkbox" ||
          event.target.type === "radio" ||
          event.target.classList.contains("cc-price-range__input"))
      ) {
        // Skip mobile-only elements on desktop
        if (shouldIgnoreElement(event.target)) {
          return;
        }

        // Prevent auto-submit on input change
        event.stopPropagation();

        // Debug mobile checkbox issues
        if (
          event.target.type === "checkbox" &&
          isMobileOnlyElement(event.target)
        ) {
        }

        // Mark checkbox/radio as changed for tracking
        if (event.target.type === "checkbox" || event.target.type === "radio") {
          event.target.setAttribute("data-has-been-changed", "true");
        }

        // Ensure mobile checkboxes are enabled
        ensureMobileCheckboxesEnabled();

        // Update filter button text if it's a checkbox
        if (event.target.type === "checkbox") {
          const filterGroup = event.target.closest(".filter-group");
          if (filterGroup) {
            const button = filterGroup.querySelector(".filter-popover-toggle");
            if (button) {
              updateFilterButtonText(button);
            }
          }
        }

        // Update price button text if it's a price input
        if (event.target.classList.contains("cc-price-range__input")) {
          const filterGroup = event.target.closest(".filter-group");
          if (filterGroup) {
            const button = filterGroup.querySelector(".price-popover-toggle");
            if (button) {
              updatePriceButtonText(button);
            }
          }
        }

        // Update overall filter button state
        updateFilterButtonState();
      }
    },
    true
  );

  // Listen for price input changes (since they're outside the form)
  document.addEventListener(
    "change",
    function (event) {
      if (event.target.classList.contains("cc-price-range__input")) {
        // Skip mobile-only elements on desktop
        if (shouldIgnoreElement(event.target)) {
          return;
        }

        // Update price button text
        const filterGroup = event.target.closest(".filter-group");
        if (filterGroup) {
          const button = filterGroup.querySelector(".price-popover-toggle");
          if (button) {
            updatePriceButtonText(button);
          }
        }

        // Update overall filter button state
        updateFilterButtonState();
      }
    },
    true
  );

  // Handle form submission for both forms
  if (desktopFilterForm) {
    desktopFilterForm.addEventListener("submit", handleFormSubmission);
  }

  if (mobileFilterForm) {
    mobileFilterForm.addEventListener("submit", handleFormSubmission);
  }

  if (filterButton) {
    filterButton.addEventListener("click", function (event) {
      handleFormSubmission(event);
    });
  }

  // Override the global selectSortOption function
  window.selectSortOption = handleSortSelection;
});

// Override the FilterContainer class behavior if it exists
if (typeof window.theme !== "undefined" && window.theme.FilterContainer) {
  const originalConstructor =
    window.theme.FilterContainer.prototype.constructor;

  window.theme.FilterContainer.prototype.constructor = function () {
    originalConstructor.call(this);

    // Remove auto-submit on change
    if (this.filters) {
      const form = this.filters.querySelector(
        "#CollectionFilterForm, #CollectionFilterFormMobile"
      );
      if (form) {
        // Remove any change event listeners that might auto-submit
        const changeElements = form.querySelectorAll("select, input");
        changeElements.forEach((element) => {
          const newElement = element.cloneNode(true);
          element.parentNode.replaceChild(newElement, element);
        });
      }
    }
  };
}
